import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "panel"]

  connect() {
    this.select()
  }

  select() {
    if (!this.hasSelectTarget) return

    const selectedId = this.selectTarget.value

    this.panelTargets.forEach(panel => {
      const active = panel.dataset.strategyOptionId === selectedId

      panel.hidden = !active
      panel.classList.toggle("hidden", !active)
      panel.setAttribute("aria-hidden", String(!active))
    })
  }
}
